import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/error/:errorCode",
    name: "error",
    component: () => import("@/modules/shared/error/views/ErrorView.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "error.404",
    component: () => import("@/modules/shared/error/views/ErrorView.vue"),
    meta: {
      requiresAuth: false,
    },
  },
];
